import { Enum, EnumType } from 'ts-jenum';
import _ from 'lodash';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faArrowRight, faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { IciFlags } from '../../../generated/signalR/ici-flags';

@Enum<IciDirection>('value')
export class IciDirection extends EnumType<IciDirection>() {
   static readonly INBOUND = new IciDirection('INBOUND', IciFlags.INBOUND, faArrowRight, 'status-inbound-answered', 'shrink-5 left-6 up-5 rotate-40');
   static readonly OUTBOUND = new IciDirection('OUTBOUND', IciFlags.OUTBOUND, faArrowLeft, 'status-outbound-answered', 'shrink-5 left-6 up-5 rotate-45');

   private constructor(
      public value: string,
      public iciFlag: IciFlags,
      public icon: IconDefinition = null,
      public styleClass: string = null,
      public iconTransformCommand: string = null
   ) {
      super();
   }

   public static getIciDirectionTypesForIci(ici: IciFlags): IciDirection[] {
      return this.values().filter((x) => x.iciFlag & ici);
   }
}
